import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals/index.css';
import App from './App';
import 'boxicons';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

